import { ng } from '@uirouter/angularjs/lib/angular';
import { StateParams, StateService } from '@uirouter/core';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import * as _ from 'underscore';
import { ViewportController } from '../../../../../app.common/modules/common/controllers/viewport-typed.controller';
import { PopupServiceCancel } from '../../../../../app.common/modules/common/models/popupServiceCancel';
import { EnumService } from '../../../../../app.common/modules/common/services/enum.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { TransferFileService } from '../../../../../app.common/modules/common/services/transferFile.service';
import { IUser } from '../../../account/model';
import { IPaginationProductsFilter } from '../../../api';
import { PhysicalProductListItem, PhysicalProductsPagingResult, PhysicalProductVariation, PhysicalProductVariationListItem, PhysicalProductVariationPrice } from '../../../core';
import { IRetailerRootScope } from '../../../core/models';
import {
    IColumnProductSortSet,
    IHttpResponseCustom,
    ILinkListItem,
    IPhysicalProductLinkListItem,
    IPhysicalProductVariation,
    IPhysicalProductVariationListItem,
    IVariationDiscount,
    IVariationStockLevel
} from '../../models';
import { ProductsService } from '../../products.service';

interface IProductStateParams {
    page: number | string;
    sort: IColumnProductSortSet;
    order: string;
    state: number | string;
    search: string;
    column: string;
}

export interface IDiscountChangeMessage {
    variationID: string;
    discount?: number;
}
class ProductsController extends ViewportController {
    public static $inject = [
        '$rootScope',
        '$scope',
        '$stateParams',
        '$q',
        '$timeout',
        'productsService',
        'popupService',
        'notificationService',
        'enumService',
        '$translate',
        '$state',
        '$localStorage',
        'transferFileService'
    ];

    public waiting = false;
    public data: PhysicalProductsPagingResult = {
        Items: [],
        Total: 0
    };
    public countryID: number;
    public isNfrnRetailer: boolean;
    public settings = {
        pageSize: 5,
        page: 1,
        sortSet: this.productsService.getSortSet(),
        sort: null as IColumnProductSortSet,
        productFilter: '',
        productState: null as number,
        isExistActiveProducts: null,
        isExistArchiveProducts: null,
        getFilter: (): IPaginationProductsFilter => {
            const i = this.settings;
            const search = i.productFilter ? i.productFilter.trim() : '';
            return {
                limit: i.pageSize,
                offset: (i.page - 1) * i.pageSize,
                sortColumn: i.sort.column,
                sortOrder: i.sort.order,
                productName: search,
                productID: '',
                productState: i.productState
            };
        },
        getStateParams: (): IProductStateParams => {
            const i = this.settings;
            const search = i.productFilter ? i.productFilter.trim() : '';
            return {
                page: encodeURIComponent(i.page.toString()),
                column: encodeURIComponent(i.sort.column),
                order: encodeURIComponent(i.sort.order),
                state: encodeURIComponent(i.productState.toString()),
                search: encodeURIComponent(search),
                sort: null
            };
        },
        settingsClear: (state: number) => {
            const i = this.settings;
            i.page = 1;
            i.sort = this.productsService.getSort();
            i.productFilter = '';
            i.productState = _.isUndefined(state)
                ? this.productState.NotArchived
                : state;
        },
        isShowFilter: () => {
            const i = this.settings;
            return (
                (this.productState.Archived === i.productState &&
                    i.isExistArchiveProducts === true) ||
                (this.productState.NotArchived === i.productState &&
                    i.isExistActiveProducts === true)
            );
        }
    };
    public isPublisher: boolean;
    public filterExpanded = false;

    private linkTypes: ILinkListItem[] = [];
    private productState = this.$rootScope.enums.PhysicalProductState;
    private params: IProductStateParams = null;
    private foodCategoryName: string = '> Meals >';

    constructor(
        private $rootScope: IRetailerRootScope,
        private $scope: ng.IScope,
        private $stateParams: StateParams,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private productsService: ProductsService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private enums: EnumService,
        private $translate: angular.translate.ITranslateService,
        private $state: StateService,
        private $localStorage: ngStorage.StorageService,
        private transferFileService: TransferFileService,
    ) {
        super($rootScope);
        this.params = {
            page: parseInt($stateParams.page, 10),
            search: decodeURIComponent($stateParams.search),
            sort: productsService.getSort(
                decodeURIComponent($stateParams.column),
                decodeURIComponent($stateParams.order)
            ),
            state: parseInt(decodeURIComponent($stateParams.state), 10)
        } as IProductStateParams;
        this.params.page = this.params.page ? this.params.page : 1;
        this.params.sort = this.params.sort
            ? this.params.sort
            : this.productsService.getSort();
        this.params.state = this.params.state
            ? this.params.state
            : this.productState.NotArchived;

        this.settings.page = this.params.page as number;
        this.settings.sort = this.params.sort;
        this.settings.productFilter = this.params.search;
        this.settings.productState = this.params.state as number;

        $scope.$watchGroup(
            ['vm.settings.productState', 'vm.settings.page'],
            (n: any, o: any) => {
                if (n !== o) {
                    this.reload();
                }
            }
        );

        const unwatch = $rootScope.$watch('userData', async (userData: IUser) => {
            if (userData.permission) {
                unwatch();
                this.isNfrnRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn;
                this.isPublisher = userData.permission === this.$rootScope.enums.RetailerPermission.Publisher;
            }
        }, true);

        this.getData();
    }

    public $onInit() {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    public goToImport() {
        this.$state.go('app.operations');
    }

    public async applyFilter(searchText: string) {
        this.settings.productFilter = searchText;
        this.settings.page = 1;
        this.search();
    }

    public getImage = (imagesID: string[], width: number, height: number) => {
        if (_.isArray(imagesID) && !_.isEmpty(imagesID)) {
            return this.productsService.getImageUrl(
                _.first(imagesID),
                width,
                height
            );
        }
        return '';
    }

    public exportcsv() {
        this.notificationService.showWaitingMessage();
        const query: {searchTerm: string; sortColumn: string; sortOrder: string} = {
            searchTerm: this.settings.productFilter,
            sortColumn: this.settings.sort.column,
            sortOrder: this.settings.sort.order
        };

        this.productsService.exportCsvProduct(query).then((response: IHttpResponseCustom<string>) => {
            const contentDisposition = response.headers('content-disposition') as string;
            const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)[1];
            this.transferFileService.transferFile(response.data, filenameMatch ? filenameMatch : `products.csv`);
            this.notificationService.clearAll();
        }).catch((error) => {
            this.notificationService.showErrorMessage(error);
        });
    }

    public archive = async (product: PhysicalProductListItem) => {
        const isDelete = _.size(product.ProductVariations) === 0;
        try {
            const popupTitle = this.$translate.instant(
                isDelete ? 'delete_product' : 'archive_product'
            );
            const popupContent = this.$translate.instant(
                isDelete ? 'delete_product_confirm' : 'archive_product_confirm'
            );

            await this.popupService.confirm({
                title: popupTitle,
                content: popupContent,
                okTxt: this.$translate.instant('no'),
                cancelTxt: this.$translate.instant('yes'),
                cancelClass: 'btn-success',
                invertAction: true
            });
            if (this.isNeedSplitProduct(product)) {
                await this.productsService.showSaveChangesDialog();
            }
            this.archiveProductInternal(product, isDelete);
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    public restoreVariation = async (
        product: PhysicalProductListItem,
        variation: PhysicalProductListItem
    ) => {
        try {
            let state = this.productState.NotArchived;
            if (this.isNeedSplitProduct(product)) {
                await this.productsService.showSaveChangesDialog();
                state = this.productState.Unassigned;
            }
            this.restoreVariationInternal(product, variation, state);
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    public openEditPrice = (
        product: PhysicalProductListItem,
        variation: IPhysicalProductVariationListItem
    ) => {
        if (this.settings.productState === this.productState.Archived) {
            return;
        }
        this.setDefaultPrice();
        variation.isFoodType = this.isFoodTypeProduct(product);
        variation.isOpenEditPrice = true;
    }

    public openEditDiscount(
        variation: IPhysicalProductVariationListItem
    ) {
        if (this.settings.productState === this.productState.Archived) {
            return;
        }
        this.setDefaultDiscount();
        variation.isOpenEditDiscount = true;
    }

    public openEditStockLevel(variation: IPhysicalProductVariationListItem) {
        if (this.settings.productState === this.productState.Archived) {
            return;
        }
        this.setDefaultStockLevel();
        variation.isOpenEditStockLevel = true;
    }

    public changeVariationStaffDiscount(
        discountMessage: IDiscountChangeMessage
    ) {
        _.forEach(
            _.flatten(_.pluck(this.data.Items, 'ProductVariations')),
            (variation: IPhysicalProductVariationListItem) => {
                variation.discount = discountMessage.discount;
            }
        );
    }

    public savePrice = async (
        changedPrice: {
            product: PhysicalProductListItem,
            variation: IPhysicalProductVariationListItem
        }
    ) => {
        if (
            this.settings.productState === this.productState.Archived ||
            !this.isValidPrice(changedPrice.variation)
        ) {
            return;
        }
        const model: PhysicalProductVariationPrice = {
            ID: changedPrice.variation.ID,
            Price: parseFloat(changedPrice.variation.price as string),
            OldPrice: _.isNaN(parseFloat(changedPrice.variation.oldPrice as string))
                ? null
                : parseFloat(changedPrice.variation.oldPrice as string),
            InsidePrice: _.isNaN(parseFloat(changedPrice.variation.insidePrice as string))
                ? null
                : parseFloat(changedPrice.variation.insidePrice as string),
            InsideVAT: _.isNaN(parseFloat(changedPrice.variation.insideVAT as string))
                ? null
                : parseFloat(changedPrice.variation.insideVAT as string),
            VAT: _.isNaN(parseFloat(changedPrice.variation.vat as string))
                ? null
                : parseFloat(changedPrice.variation.vat as string),
        };
        if (!model.InsidePrice) {
            model.InsideVAT = null;
        }
        try {
            if (this.isNeedSplitProduct(changedPrice.product)) {
                await this.productsService.showSaveChangesDialog();
            }
            this.savePriceInternal(changedPrice.product, changedPrice.variation, model);
        } catch (error) {
            if (PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.setDefaultPrice();
            } else {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    public async saveDiscount(
        changedDiscount: {
            product: PhysicalProductListItem,
            variation: IPhysicalProductVariationListItem
        }
    ) {
        if (this.settings.productState === this.productState.Archived) {
            return;
        }
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        const model: IVariationDiscount = {
            ID: changedDiscount.variation.ID,
            Discount: parseFloat(changedDiscount.variation.discount as string)
        };

        try {
            const result = await this.productsService.updateDiscount(
                changedDiscount.product.ID,
                model
            );
            if (changedDiscount.product.ID === result) {
                this.notificationService.showSuccessMessage();
                changedDiscount.variation.Discount = changedDiscount.variation.discount as number;
                changedDiscount.variation.isOpenEditDiscount = false;
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    public async saveStockLevel(productId: string, variationId: string, stockLevel: number | null) {
        if (this.settings.productState === this.productState.Archived) {
            return;
        }
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        const model: IVariationStockLevel = {
            ID: variationId,
            StockQuantity: stockLevel
        };
        try {
            const result = await this.productsService.updateStockLevel(productId, model);
            if (productId === result) {
                const product = this.data.Items.find((item) => item.ID === productId);
                const variation: IPhysicalProductVariationListItem = product.ProductVariations.find((item) => item.ID === variationId) as IPhysicalProductVariationListItem;
                variation.StockQuantity = stockLevel;
                variation.isOpenEditStockLevel = false;
                this.notificationService.showSuccessMessage();
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    public cancelPrice() {
        this.setDefaultPrice();
    }

    public cancelDiscount() {
        this.setDefaultDiscount();
    }

    public cancelStockLevel() {
        this.setDefaultStockLevel();
    }

    public importProducts = async () => {
        try {
            await this.productsService.productsImport();
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClick(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    public async resetSearch() {
        this.settings.productFilter = null;
        this.search();
    }

    private async search() {
        this.waiting = true;
        try {
            this.notificationService.showWaitingMessage();
            this.data = await this.productsService.getProducts(this.settings.getFilter());
            this.adaptData();
            this.notificationService.clearAll();
        } catch (e) {
            this.notificationService.showErrorMessage(e);
        }
        this.waiting = false;
    }

    private setClientBadges(products: PhysicalProductListItem[]) {
        const variations = _.flatten(_.pluck(products, 'ProductVariations')) as PhysicalProductVariation[];
        _.forEach(variations, (variation) => {
            (variation as IPhysicalProductVariation).badges = this.productsService.getClientBadges(variation.Badges, true);
        });
    }

    private adaptData() {
        this.setClientBadges(this.data.Items);
        _.forEach(this.data.Items as PhysicalProductListItem[], (product) => {
            _.forEach(product.ProductLinks as IPhysicalProductLinkListItem[], (link) => {
                link.viewClass = _.findWhere(this.linkTypes, { ID: link.Type }).viewClass;
            });
        });
        this.$timeout(() => {
            $('.wrapUlTags.overflowY').slimScroll({
                height: 'auto'
            });

            ($('.wysiwyg__main') as any).mCustomScrollbar({
                axis: 'y',
                theme: 'minimal-dark'
            });
        });
    }

    private reload() {
        this.$rootScope.$state.go(
            'app.products',
            this.settings.getStateParams()
        );
    }

    private getData = async () => {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {

            const response = await this.$q.all([this.productsService.getProducts(this.settings.getFilter()), this.productsService.getLinkTypes() as angular.IPromise<ILinkListItem[]>, this.productsService.isExistProducts(this.productState.NotArchived), this.productsService.isExistProducts(this.productState.Archived), this.productsService.isExistProducts(this.productState.Unassigned)]);
            this.notificationService.clearAll();
            this.data = response[0];
            this.linkTypes = response[1];
            this.settings.isExistActiveProducts = response[2];
            this.settings.isExistArchiveProducts = response[3];
            this.adaptData();
            if (
                this.data.Total === 0 &&
                !_.isEmpty(this.settings.productFilter)
            ) {
                this.notificationService.showInfoMessage(null);
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private isNeedSplitProduct(product: PhysicalProductListItem) {
        if (this.$rootScope.userData) {
            console.log(this.$rootScope.userData.permission);
            console.log(this.$rootScope.enums.RetailerPermission.Retailer);
        }
        return !(
            this.$rootScope.userData &&
          (this.$rootScope.userData.permission ===
            this.$rootScope.enums.RetailerPermission.Retailer ||
            this.$rootScope.userData.permission ===
            this.$rootScope.enums.RetailerPermission.Publisher)
        );
    }

    private archiveProductInternal = async (
        product: PhysicalProductListItem,
        isDelete: boolean
    ) => {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            const id = await this.productsService.archiveProduct(product.ID);
            if (
                isDelete &&
                this.settings.productState !== this.productState.Archived
            ) {
                this.settings.settingsClear(this.productState.Archived);
            } else {
                this.getData();
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private $restoreVariation = async (
        productID: string,
        variationID: string,
        productState: number
    ) => {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            const id = await this.productsService.restoreVariation(
                productID,
                variationID
            );
            this.settings.settingsClear(productState);
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private restoreVariationInternal = async (
        product: PhysicalProductListItem,
        variation: PhysicalProductVariationListItem,
        productState
    ) => {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            const twins = await this.productsService.getTwinsVariations(
                product.ID,
                variation.ID
            );
            if (!_.isEmpty(twins)) {
                await this.popupService.confirm({
                    title: this.$translate.instant('override_variation'),
                    content: `<p>${this.$translate.instant(
                        'override_variation_confirm'
                    )}'</p>`
                });
            }
            await this.$restoreVariation(
                product.ID,
                variation.ID,
                productState
            );
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
        this.waiting = false;
    }

    private setDefaultPrice = () => {
        _.forEach(
            _.flatten(_.pluck(this.data.Items, 'ProductVariations')),
            (variation: IPhysicalProductVariationListItem) => {
                variation.price = variation.Price;
                variation.oldPrice = variation.OldPrice;
                variation.insidePrice = variation.InsidePrice;
                variation.insideVAT = variation.InsideVAT;
                variation.vat = variation.VAT;
                variation.isOpenEditDiscount = false;
                variation.isOpenEditPrice = false;
                variation.isOpenEditStockLevel = false;
                variation.error = null;
            }
        );
    }

    private setDefaultDiscount = () => {
        _.forEach(
            _.flatten(_.pluck(this.data.Items, 'ProductVariations')),
            (variation: IPhysicalProductVariationListItem) => {
                variation.discount = variation.Discount;
                variation.isOpenEditDiscount = false;
                variation.isOpenEditPrice = false;
                variation.isOpenEditStockLevel = false;
            }
        );
    }

    private setDefaultStockLevel = () => {
        _.forEach(
            _.flatten(_.pluck(this.data.Items, 'ProductVariations')),
            (variation: IPhysicalProductVariationListItem) => {
                variation.isOpenEditDiscount = false;
                variation.isOpenEditPrice = false;
                variation.isOpenEditStockLevel = false;
            }
        );
    }

    private isValidPrice(variation: IPhysicalProductVariationListItem) {
        variation.error = {
            noPrice: null,
            takeawayGreatEatIn: null,
            oldPriceIsSmall: null
        };
        if (
            _.isNaN(parseFloat(variation.price as string)) ||
            (!_.isNaN(parseFloat(variation.price as string)) &&
                variation.price <= 0)
        ) {
            variation.error.noPrice = true;
        } else if (
            !_.isNaN(parseFloat(variation.oldPrice as string)) &&
            parseFloat(variation.oldPrice as string) <=
            parseFloat(variation.price as string)
        ) {
            variation.error.oldPriceIsSmall = true;
        } else if (
            !_.isNaN(parseFloat(variation.price as string)) &&
            parseFloat(variation.insidePrice as string) !==
            parseFloat(variation.price as string) &&
            parseFloat(variation.insidePrice as string) <
            parseFloat(variation.price as string)
        ) {
            variation.error.takeawayGreatEatIn = true;
        } else {
            variation.error.noPrice = null;
            variation.error.oldPriceIsSmall = null;
            variation.error.takeawayGreatEatIn = null;
        }

        return (
            variation.error.noPrice == null &&
            variation.error.takeawayGreatEatIn == null &&
            variation.error.oldPriceIsSmall == null
        );
    }

    private savePriceInternal = async (
        product: PhysicalProductListItem,
        variation: IPhysicalProductVariationListItem,
        model: PhysicalProductVariationPrice
    ) => {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            const id = await this.productsService.updatePriceWithVat(product.ID, model);
            if (product.ID === id) {
                this.notificationService.showSuccessMessage();
                variation.Price = model.Price as number;
                variation.OldPrice = model.OldPrice as number;
                variation.InsidePrice = model.InsidePrice as number;
                variation.InsideVAT = model.InsideVAT as number;
                variation.VAT = model.VAT as number;
                variation.isOpenEditPrice = false;
                this.setDefaultPrice();
            } else {
                if (
                    this.settings.productState === this.productState.Unassigned
                ) {
                    this.getData();
                } else {
                    this.settings.settingsClear(this.productState.Unassigned);
                }
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private isFoodTypeProduct(product: PhysicalProductListItem) {
        return product.ClassificationCategory && product.ClassificationCategory.FullName &&
            product.ClassificationCategory.FullName.indexOf(
                this.foodCategoryName
            ) > 0;
    }
}

angular
    .module('naut').component('products', {
        template: require('./products.html'),
        controller: ProductsController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/products/products.component.ts